import React, { useState } from 'react';
import axios from 'axios';
import { Button, Spinner, Form, Container, Row, Col, Alert } from 'react-bootstrap';
import { ClipboardData } from 'react-bootstrap-icons'; // Importing the icon
import 'bootstrap/dist/css/bootstrap.min.css';

const UrlShortener = () => {
    const [longUrl, setLongUrl] = useState('');
    const [shortUrl, setShortUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        
        e.preventDefault();
        
        setLoading(true);
        setError(''); // Reset error message
        const shortyUrl = `${process.env.REACT_APP_API}/api/shorty/shorten`;
        console.log(shortyUrl)
        try {
            const response = await axios.post(shortyUrl, { originalUrl: longUrl });
            setShortUrl(response.data.shortUrl);
            setLongUrl('');
        } catch (error) {
            setError('Error shortening URL. Please try again.');
            console.error('Error shortening URL', error);
        } finally {
            setLoading(false);
        }
    };

    const copyToClipboard = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            // Use the Clipboard API if available
            navigator.clipboard.writeText(shortUrl)
                .then(() => {
                    alert('Shortened URL copied to clipboard!');
                })
                .catch(err => {
                    console.error('Failed to copy: ', err);
                });
        } else {
            // Fallback for older browsers
            const textarea = document.createElement('textarea');
            textarea.value = shortUrl;
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                alert('Shortened URL copied to clipboard!');
            } catch (err) {
                console.error('Failed to copy: ', err);
            } finally {
                document.body.removeChild(textarea);
            }
        }
    };

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={6}>
                    <h1 className="text-center bi bi-align-center">URL Shortener</h1>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formBasicUrl">
                            <Form.Label>Enter your URL</Form.Label>
                            <Form.Control
                                type="url"
                                placeholder="https://example.com"
                                value={longUrl}
                                onChange={(e) => setLongUrl(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                            {loading ? (
                                <>
                                    <Spinner animation="border" size="sm" /> Shortening...
                                </>
                            ) : (
                                'Shorten URL'
                            )}
                        </Button>
                    </Form>
                    {shortUrl && (
                        <Alert variant="success" className="mt-3">
                            Shortened URL: <a href={`${shortUrl}`}>{shortUrl}</a>
                            <Button 
                                variant="outline-secondary" 
                                className="w-100" 
                                onClick={copyToClipboard}
                            >
                                <ClipboardData size={16} /> Copy
                            </Button>
                        </Alert>
                    )}
                    {error && (
                        <Alert variant="danger" className="mt-3">
                            {error}
                        </Alert>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default UrlShortener;
